module.exports = __webpack_public_path__ + "static/media/details-4-image-2.176a02dc.jpg";